export const SANDBOX_API_URL = 'https://api.sandbox.getalma.eu'
export const LIVE_API_URL = 'https://api.getalma.eu'

export enum ApiMode {
  LIVE = 'https://api.getalma.eu',
  TEST = 'https://api.sandbox.getalma.eu',
}
